module.exports = __webpack_public_path__ + "static/media/100_percent.3ce26ebd.webp";